import React, {PropsWithChildren} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../hooks/use-services.hook";
import {AgencySideMenuComponent} from "../../components/agency/side-menu/agency-side-menu.component";
import {RoutedPageComponent} from "../../basic-components/page/routed-page/routed-page.component";
import {
    StandardPageHeaderSmallScreenComponent
} from "../../basic-components/page/standard-page-header/standard-page-header.small-screen.component";
import {HomePageStandardContentWebappComponent} from "../home/web/boxes/home-page-content-wrapper.webapp.box";

import {CopyRightComponent} from "../../components/airline-company-info/copy-right.component";
import styled from "styled-components";
import {AgencyLoginFormComponent} from "../../components/agency/login-form/agency-login-form.component";
import {useScreenMediaQueriesChecks} from "../../hooks/use-screen-media-queries-checks.hook";
import {
    StandardPageHeaderLargeScreenComponent
} from "../../basic-components/page/standard-page-header/standard-page-header.large-screen.component";
import {SpinnerComponent} from "../../components/spinner/spinner.component";
import {
    StandardPageFooterComponent
} from "../../basic-components/page/standard-page-footer/standard-page-footer.component";
import {BurgerMenuComponent} from "../../components/burger-menu/burger-menu.component";

const ContentBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex-grow: 1;
`


interface AgencyPageProps extends PropsWithChildren {
    className?: string;
    footer?: {
        renderFooterContent?: () => React.ReactNode;
    }
    content?: {
        contentCssClass?: string;
        reducePaddingTopOnScroll?: boolean;
    }
}

export const AgencyPage: React.FC<AgencyPageProps> = observer((props) => {
    const services = useServices();
    const mediaQuery = useScreenMediaQueriesChecks();

    const onLogoClick = async () => {
        if(services.navigator.currentRoute.isHome) {
            await services.navigator.gotToWebsiteHome();
        } else {
            await services.navigator.goHome();
        }
    }

    const renderSideMenu = () => {
        if(services.user.isAuthorized) {
            return (
                <AgencySideMenuComponent key={"AGENCY_SIDE_MENU_COMPONENT"}/>
            )
        }
        return null;
    }
    const renderBurgerMenu = () => {
        if(!services.user.isAuthorized) {
            return null;
        }
        return (
            <BurgerMenuComponent sideMenuController={services.sideMenu.agencyMainSideMenuController}/>
        )
    }

    const renderHeader = () => {
        if(mediaQuery.smallScreen) {
            return (
                <StandardPageHeaderSmallScreenComponent useLargeLogoOnSmallScreen={true}
                                                        onLogoButtonClick={onLogoClick}
                                                        renderBurgerMenu={renderBurgerMenu}/>
            )
        } else {
            return (
                <StandardPageHeaderLargeScreenComponent onLogoButtonClick={onLogoClick}
                                                        renderBurgerMenu={renderBurgerMenu}/>
            )
        }
    }

    const renderContent = () => {
        if(!services.user.profile.isProfileInitialized) {
            return (
                <SpinnerComponent/>
            );
        }
        if(services.user.isAuthorized) {
            return props.children;
        } else {
            return (
                <AgencyLoginFormComponent/>
            );
        }
    }

    const renderFooter = () => {
        if(props.footer?.renderFooterContent) {
            return (
                <StandardPageFooterComponent>
                    {props.footer.renderFooterContent()}
                </StandardPageFooterComponent>
            );
        }
        return null;
    }

    return (
        <>
            {renderSideMenu()}
            <RoutedPageComponent id={services.sideMenu.agencyMainSideMenuController.contentId}
                                 disableSwipeNavigation={true}
                                 className={props.className}>
                {renderHeader()}
                <HomePageStandardContentWebappComponent reducePaddingTopOnScroll={props.content?.reducePaddingTopOnScroll}>
                    <ContentBox className={props.content?.contentCssClass}>
                        {renderContent()}
                    </ContentBox>
                    <CopyRightComponent/>
                </HomePageStandardContentWebappComponent>
                {renderFooter()}
            </RoutedPageComponent>
        </>
    );
})